<template>
  <div class="modal__content">
    <img v-if="background" class="modal__img" :src="background" alt="">
    <p v-if="description" class="modal__description" v-html="description" />
  </div>
</template>

<script>
// Vuex
import { mapGetters } from 'vuex'

export default {
  name: `view-name`,

  // Components
  // Data
  // Computed
  computed: {
    ...mapGetters(`modal`, [`content`]),

    background () {
      if (!this.content || !this.content.img) return

      return this.content.img
    },

    description () {
      if (!this.content || !this.content.desc) return

      return this.content.desc
    }
  }
  // Methods
  // Watchers
  // Lifecycles
  // Filters
}
</script>
